import { render, staticRenderFns } from "./sync-s3-images-form.vue?vue&type=template&id=bb7c6e20"
import script from "./sync-s3-images-form.vue?vue&type=script&lang=js"
export * from "./sync-s3-images-form.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports